import { render, staticRenderFns } from "./rejectAndStopModal.vue?vue&type=template&id=61dd8646&scoped=true"
import script from "./rejectAndStopModal.vue?vue&type=script&lang=js"
export * from "./rejectAndStopModal.vue?vue&type=script&lang=js"
import style0 from "./rejectAndStopModal.vue?vue&type=style&index=0&id=61dd8646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd8646",
  null
  
)

export default component.exports